import { computed, ref, unref, watch } from 'vue'
import { type ComputedRef } from 'vue'
import type { BasicTableProps, PaginationProps } from '../type'
import { usePageCache } from '@/hooks/usePageCache'
import { saveColumnWidthApi } from '@/apis/common'
import { useResource } from '@/hooks/useResource'
export function usePagination(props: ComputedRef<BasicTableProps>, _tableCode?: string) {
  const { updateCache, getCache } = usePageCache()
  const defaultPageSize = 20
  // usePageCache：如果props更新了pagination
  watch(
    () => unref(props).pagination,
    pagination => {
      // 这里也要取更新一下缓存
      if (pagination) {
        updateCache({
          table: {
            searchInfo: {
              pageSize: pagination.pageSize,
              pageNum: pagination.pageNum
            }
          }
        })
        // updateCache({ table: { pageNum: pagination.pageNum } })
      }
      paginationInfo.value = pagination ?? paginationInfo.value
    }
  )
  // 监听一下useCache变化
  watch(
    () => unref(props).useCache,
    val => {
      if (val) {
        paginationInfo.value = {
          pageSize: cache.pageSize || defaultPageSize,
          pageNum: cache.pageNum || 1
        }
      }
    }
  )
  // usePageCache：取缓存的page
  const cache = getCache()?.table || {}
  const paginationInfo = ref<PaginationProps>({
    pageSize: defaultPageSize,
    pageNum: 1
  })
  const pageSizes = [10, 20, 50, 100, 200]
  const getPaginationInfo = computed((): PaginationProps => {
    return { ...unref(paginationInfo) }
  })
  // 修改分页
  async function handleSizeChange(val: number) {
    updateCache({ table: { searchInfo: { pageSize: val } } })
    paginationInfo.value.pageSize = val
    // 标识
    const KEY = 'vPaginationKey'
    const { getMenuAppCode } = useResource()
    const APPCODE = getMenuAppCode()
    if (props.value?.customTableConfig) {
      const tableCode = props.value?.tableCode || APPCODE
      tableCode &&
        (await saveColumnWidthApi({
          columnKey: KEY,
          value: val,
          businessKey: tableCode + KEY
        }))
    }
  }
  function handleCurrentChange(val: number) {
    updateCache({ table: { searchInfo: { pageNum: val } } })
    paginationInfo.value.pageNum = val
  }
  function setPaginationInfo(info: Recordable) {
    paginationInfo.value = {
      ...paginationInfo.value,
      ...info
    }
  }
  return {
    getPaginationInfo,
    handleSizeChange,
    handleCurrentChange,
    pageSizes,
    setPaginationInfo
  }
}
